import Cookies from 'js-cookie';
import { getDomain } from '../utils/domain';
import { defaultLanguage } from '../config/i18n';

const OTP_TOKEN_KEY = '@mlabs-otp-token';
const TOKEN_KEY = '@mlabs-token';
const ACCOUNT_TYPE = '@mlabs-account-type';
const LANGUAGE_KEY = '@mlabs-language';
const DISMISS_BANNER = 'mlabs-dismiss-banner';
export const TRACKING_REGISTER = '@tracking-register';

export const hasOtpToken = () => localStorage.getItem(OTP_TOKEN_KEY) !== null && localStorage.getItem(OTP_TOKEN_KEY) != 'null' && localStorage.getItem(OTP_TOKEN_KEY) != 'undefined';
export const getOtpToken = () => localStorage.getItem(OTP_TOKEN_KEY);
export const setOtpToken = (token) => {
  localStorage.setItem(OTP_TOKEN_KEY, token);
};

export const getToken = () => {
  const authTokenCookie = Cookies.get('authToken')
  if (authTokenCookie) {
    const parsed = JSON.parse(decodeURIComponent(authTokenCookie));
    if (parsed.authenticated) {
      const token = parsed.authenticated['token']
      if (token && token != '' && token != 'null' && token != 'undefined' && token != undefined) {
        return token
      }
    }
  }
  return localStorage.getItem(TOKEN_KEY);
}

export const login = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TRACKING_REGISTER);
  localStorage.removeItem(OTP_TOKEN_KEY);
};

export const setAccountType = (value) => localStorage.setItem(ACCOUNT_TYPE, value);

export const getAccountType = () => localStorage.getItem(ACCOUNT_TYPE);

export const removeAccountType = () => localStorage.removeItem(ACCOUNT_TYPE);

export const getLanguage = () => Cookies.get(LANGUAGE_KEY) || defaultLanguage;

export const removeCookie = () => {
  Cookies.remove(DISMISS_BANNER, {
    domain: getDomain(),
  });
};
